import { DashboardPage } from "pages/dashboard";
import { PracticesPage } from "pages/practices";
import { HomePage } from "pages/home";
import { MySocialReportsPage } from "pages/my-social-reports";
import { SearchesPage } from "pages/searches";
import { SocialPage } from "pages/social";
import { PracticeDetailPage } from "pages/practice-detail";
import { AdminPage } from "pages/admin";
import { AdminUsagePage } from "pages/admin-usage";
import { MyProfilePage } from "pages/my-profile";
import { DomainsPage } from "pages/domains";
import { UrlDetailPage } from "pages/url-detail";
import { ConfigurationPage } from "pages/configuration";
import { ThermsAndConditions } from "pages/therms-and-conditions";
import { NewsPage } from "pages/news";
import { TakedownPage, TakedownListPage, UserRemovals } from "pages/takedown";

const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/web-rep/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/web-rep/searches",
    element: <SearchesPage />,
  },
  // {
  //   path: "/web-rep/reports",
  //   element: <ReportsPage />,
  // },
  {
    path: "/web-rep/practices",
    element: <PracticesPage />,
  },
  {
    path: "/web-rep/practices/:id",
    element: <PracticeDetailPage />,
  },
  {
    path: "/web-rep/practices/:id/:url_id",
    element: <UrlDetailPage />,
  },
  // {
  //   path: "/web-rep/favourite-urls",
  //   element: <FavouriteUrlPage />,
  // },
  {
    path: "/social/instagram-account",
    element: <SocialPage />,
  },
  {
    path: "/social/my-social-reports",
    element: <MySocialReportsPage />,
  },
  {
    path: "/web-rep/admin",
    element: <AdminPage />,
  },
  {
    path: "/web-rep/admin/usage",
    element: <AdminUsagePage />,
  },
  {
    path: "/social",
    element: <></>,
  },
  {
    path: "/my-profile",
    element: <MyProfilePage />,
  },
  {
    path: "/web-rep/domains",
    element: <DomainsPage />,
  },
  {
    path: "/web-rep/takedown",
    element: <TakedownListPage />,
  },
  {
    path: "/web-rep/takedown/:practiceId",
    element: <TakedownPage />,
  },
  {
    // Vista end-user "Le tue rimozioni" (GET /account/removals, simple_auth)
    path: "/web-rep/removals",
    element: <UserRemovals />,
  },
  {
    path: "/web-rep/configuration",
    element: <ConfigurationPage />,
  },
  {
    path: "/tos",
    element: <ThermsAndConditions />,
  },
  {
    // Pagina Novità — non ancora collegata al menu (accessibile via URL diretto)
    path: "/news",
    element: <NewsPage />,
  },
];

export default routes;
